import http_request from './http_request'
import config from 'config'

function getPendingIcons(actualSlideId) {
	return http_request.get(config.api + 'icons/pending')
		.send({
			actualSlideId,
		})
}

function validateFilesPicked(allowedTypes, files, presentationId = 0, slideId = 0, force = false) {
	return http_request.get(config.api + 'icons/validations')
		.send({
			allowed_types: JSON.stringify(allowedTypes),
			icons: encodeURI(JSON.stringify(files)),
			presentation_id: presentationId,
			slide_id: slideId,
			force,
		})
}

function uploadFilePicked(uploadId, file, entity, featureType, featureId, entityIconType, allowedTypes, presentationId = 0, slideId = 0, force = false) {
	const fileName = entity.fileName || null
	const formData = new FormData()
	formData.append('uploadId', uploadId)
	if (fileName) {
		formData.append('file', file, fileName)
	} else {
		formData.append('file', file)
	}
	formData.append('icon', JSON.stringify(entity))
	formData.append('entityType', featureType)
	formData.append('entityId', featureId)
	formData.append('entityIconType', entityIconType)
	formData.append('presentationId', presentationId)
	formData.append('slideId', slideId)
	formData.append('force', force)
	formData.append('allowed_types', JSON.stringify(allowedTypes))

	return http_request.post(config.api + 'icons')
		.type('')
		.send(formData)

}

function getIcon(id, featureType, featureId, entityIconType) {
	return http_request.get(config.api + 'icons/' + id)
		.send({
			entityType: featureType,
			entityId: featureId,
			entityIconType,
		})
}

function getIcons(ids) {
	return http_request.get(config.api + 'icons')
		.send({
			ids: JSON.stringify(ids),
		})
}

function cancelUpload(uploadId) {
	return http_request.delete(config.api + 'icons/upload')
		.send({
			uploadId,
		})
}

export default {
	validateFilesPicked,
	uploadFilePicked,
	getIcons,
	getPendingIcons,
	getIcon,
	cancelUpload,
}
